import React, { useCallback } from 'react';
import { string, number } from 'prop-types';
import { useGTM } from '@hooks';
import { useHeaderContext } from '@context';
import styles from './styles/index.module.scss';

const QuickAccessFamily = ({ level, name, url }) => {
  const { platformBaseUrl } = useHeaderContext();
  const [pushToGTM] = useGTM();

  const handleClick = useCallback(() => {
    pushToGTM({
      event: 'click_on_navmenu_item',
      event_trigger: 'quick-access',
      navmenu_item_level: level,
      navmenu_item_destination: url,
    });
  }, [level, url]);
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <a href={`${platformBaseUrl}${url}`} onClick={handleClick}>
          {name}
        </a>
      </div>
    </div>
  );
};

QuickAccessFamily.propTypes = {
  level: number.isRequired,
  url: string.isRequired,
  name: string.isRequired,
};

QuickAccessFamily.displayName = 'QuickAccessFamily';

export default QuickAccessFamily;
